import type { DocLink } from 'src/types/helios/Question';
import { SOURCE_SOP_DOC_TITLE } from 'src/utils/docLinkUtils';

import { buildPolicyUrl } from './policyUrlValidation';

/**
 * The doc links to seed a drafted Astra question with for its source SOP: one
 * `isSourceSop` link (stored title + the reconstructed policy URL) when the
 * agent cited a well-formed (digits-only) policy id, none otherwise —
 * {@link buildPolicyUrl} rejects a blank or malformed id, so a garbage
 * `source_policy_id` never becomes a locked, un-removable broken link.
 * Returns a list so a question generated from several SOPs is just more
 * entries — no shape change.
 */
export function buildSourceSopDocLinks(sourcePolicyId: string): DocLink[] {
  const link = buildPolicyUrl(sourcePolicyId);
  if (link === undefined) return [];
  return [{ title: SOURCE_SOP_DOC_TITLE, link, isSourceSop: true }];
}
